import TechnologyExpertiseSection from "./_components/technology-expertise-section";

export default TechnologyExpertiseSection;
